import {has} from 'lodash';
import {GET_TV_SHOWS, HANDLE_TV_SHOWS_ERROR} from '../constants';
import {processCustomCategories} from '../../utils';

const initState = {
	data: [],
};
const tvshows = (state = initState, action) => {
	switch (action.type) {
		case GET_TV_SHOWS:
			return {...state, data: [...processShowsData(state, action)]};
		case HANDLE_TV_SHOWS_ERROR:
			return {
				...state,
				data: null,
				errorCode: action.errorCode,
			};
		default:
			return state;
	}
};

const processShowsData = (state, action) => {
	let retData = [];
	if (action.shows) {
		retData = action.shows.map((item) => {
			const ret = {};
			if (has(item, 'series')) {
				ret.id = has(item.series, 'id') ? item.series.id : null;
				ret.slug = has(item.series, 'slug') ? item.series.slug : '';
				ret.name = has(item.series, 'name') ? item.series.name : '';
				ret.description = has(item.series, 'description') ? item.series.description : '';
				ret.coverImage = has(item.series, 'coverImage') ? item.series.coverImage : '';
			}
			if (has(item, 'latest')) {
				[...ret.latest] = item.latest;
			}
			return ret;
		});
	}
	return processCustomCategories(retData, true);
};

export default tvshows;
